import moment from "moment-timezone";
import Image from "next/image";
import { useEffect } from "react";
import { TYPO } from "styles/Typo";
import { NewBriefingIcon } from "../main/feed/BriefingAd";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";

function BriefingAllViewed({
  date,
  isMobile,
  isFinishPage,
}: {
  date: string;
  isMobile: boolean;
  isFinishPage: boolean;
}) {
  useEffect(() => {
    if (isFinishPage) {
      localStorage.setItem("briefingDate", date);
    }
  }, [isFinishPage, date]);
  return (
    <div className="flex flex-col gap-1 justify-center items-center">
      <p className={`text-gray80 ${TYPO.TYPO7_RG}`}>오늘은 여기까지</p>
      <p className={`text-gray80 ${TYPO.TYPO4_SB}`}>
        다음 브리핑이 올라오면 알려드릴까요?
      </p>
      <div
        style={{
          height: isMobile
            ? "calc(100dvh - 170px - 56px - 144px)"
            : "calc(100dvh - 170px - 56px - 144px - 68px)",
        }}
        className="flex justify-center items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
        >
          <rect width="120" height="120" rx="32" fill="var(--gray80)" />
          <rect x="20" y="28" width="80" height="64" rx="16" fill="#CFD8E1" />
          <path
            d="M58.2617 60.462C59.0515 59.859 60.1458 59.8533 60.9414 60.4483L95.9385 86.6377C93.0083 89.9218 88.7447 91.9903 83.9971 91.9903H35.9971C31.2318 91.9903 26.9546 89.906 24.0234 86.6006L58.2617 60.462Z"
            fill={TAILWIND_TO_CSS["gray5"]}
          />
          <path
            d="M85.1852 28H34.8148C26.6328 28 20 34.6328 20 42.8148L49.4325 68.7045C55.475 74.0196 64.525 74.0196 70.5675 68.7045L100 42.8148C100 34.6328 93.3672 28 85.1852 28Z"
            fill={TAILWIND_TO_CSS["gray40"]}
          />
          <path
            d="M85.3333 28H34.6667C26.5665 28 20 34.5665 20 42.6667L50.5382 65.0613C56.17 69.1914 63.83 69.1914 69.4618 65.0613L100 42.6667C100 34.5665 93.4335 28 85.3333 28Z"
            fill={TAILWIND_TO_CSS["gray5"]}
          />
          <path
            d="M91.25 32.2501L88.5625 29.5626C88.3333 29.3335 88.0417 29.2189 87.6875 29.2189C87.3333 29.2189 87.0417 29.3335 86.8125 29.5626C86.5833 29.7918 86.4688 30.0835 86.4688 30.4376C86.4688 30.7918 86.5833 31.0835 86.8125 31.3126L90.375 34.8751C90.625 35.1251 90.9167 35.2501 91.25 35.2501C91.5833 35.2501 91.875 35.1251 92.125 34.8751L99.1875 27.8126C99.4167 27.5835 99.5312 27.2918 99.5312 26.9376C99.5312 26.5835 99.4167 26.2918 99.1875 26.0626C98.9583 25.8335 98.6667 25.7189 98.3125 25.7189C97.9583 25.7189 97.6667 25.8335 97.4375 26.0626L91.25 32.2501ZM93 42.5001C91.2708 42.5001 89.6458 42.172 88.125 41.5157C86.6042 40.8595 85.2812 39.9689 84.1562 38.8439C83.0312 37.7189 82.1406 36.396 81.4844 34.8751C80.8281 33.3543 80.5 31.7293 80.5 30.0001C80.5 28.271 80.8281 26.646 81.4844 25.1251C82.1406 23.6043 83.0312 22.2814 84.1562 21.1564C85.2812 20.0314 86.6042 19.1407 88.125 18.4845C89.6458 17.8282 91.2708 17.5001 93 17.5001C94.7292 17.5001 96.3542 17.8282 97.875 18.4845C99.3958 19.1407 100.719 20.0314 101.844 21.1564C102.969 22.2814 103.859 23.6043 104.516 25.1251C105.172 26.646 105.5 28.271 105.5 30.0001C105.5 31.7293 105.172 33.3543 104.516 34.8751C103.859 36.396 102.969 37.7189 101.844 38.8439C100.719 39.9689 99.3958 40.8595 97.875 41.5157C96.3542 42.172 94.7292 42.5001 93 42.5001Z"
            fill={TAILWIND_TO_CSS["risk-green"]}
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M88.5605 29.5664L91.248 32.2539L97.4355 26.0664C97.6647 25.8372 97.9564 25.7226 98.3105 25.7226C98.6647 25.7226 98.9564 25.8372 99.1855 26.0664C99.4147 26.2955 99.5293 26.5872 99.5293 26.9414C99.5293 27.2955 99.4147 27.5872 99.1855 27.8164L92.123 34.8789C91.873 35.1289 91.5814 35.2539 91.248 35.2539C90.9147 35.2539 90.623 35.1289 90.373 34.8789L86.8105 31.3164C86.5814 31.0872 86.4668 30.7955 86.4668 30.4414C86.4668 30.0872 86.5814 29.7955 86.8105 29.5664C87.0397 29.3372 87.3314 29.2226 87.6855 29.2226C88.0397 29.2226 88.3314 29.3372 88.5605 29.5664Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  );
}

export default BriefingAllViewed;
